export default __webpack_public_path__ + "static/media/siebe-chugelrundi-saeu.ed361294.webp";